import Vue from "vue";
import VueRouter from "vue-router";
import Layout from '@/layout'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: ":magName?/:magId?",
        name: "Home",
        component: () => import("@/views/home/index"),
        meta: { title: "首页", icon: "home" }
      }
    ]
  },
  {
    path: "/mobile",
    component: Layout,
    children: [
      {
        path: ":magName?/:magId?",
        name: "Home",
        component: () => import("@/views/mobile/index"),
        meta: { title: "首页", icon: "home" }
      }
    ]
  },

  { path: "*", redirect: "/404", hidden: true },

];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
